"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckoutImage = void 0;
var _checkoutImageTypes = require("./checkoutImageTypes");
var _constants = require("./constants");
function getSizeConstants(size) {
  switch (size) {
    case 'small':
      return {
        sizeValue: _constants.SMALL,
        fontSizeValue: _constants.SMALL_FONT_SIZE
      };
    case 'large':
      return {
        sizeValue: _constants.LARGE,
        fontSizeValue: _constants.LARGE_FONT_SIZE
      };
    case 'basketItem':
      return {
        sizeValue: _constants.BASKETITEM,
        fontSizeValue: _constants.BASKETITEM_FONT_SIZE
      };
    case 'basketItemSmall':
      return {
        sizeValue: _constants.BASKETITEM,
        fontSizeValue: _constants.BASKETITEM_FONT_SIZE
      };
    default:
      return {
        sizeValue: _constants.MEDIUM,
        fontSizeValue: _constants.MEDIUM_FONT_SIZE
      };
  }
}
const useCheckoutImage = data => {
  const {
    src,
    background = _constants.BACKGROUND,
    size = _constants.SIZE
  } = data;
  const sizeObject = getSizeConstants(size);
  const {
    sizeValue,
    fontSizeValue
  } = sizeObject;
  const backgroundColor = background;
  let urlSrc = src;
  if (src === _checkoutImageTypes.CheckoutSrcOptions.noImage) {
    return {
      imageSrc: 'missing',
      sizeValue,
      backgroundColor,
      fontSizeValue
    };
  }
  // sorting up the surprise image
  if (src === _checkoutImageTypes.CheckoutSrcOptions.surprise || src.toLocaleLowerCase().includes(_constants.SURPRISE_LINK_SNIPPET)) {
    urlSrc = _constants.SURPRISE_LINK;
  }
  const sizeParams = `&w=${sizeValue.md * 3}&h=${sizeValue.md * 3}`;
  const url = new URL(urlSrc);
  const params = url.searchParams;
  const baseParams = params.get('externalMediaId');
  // additional params
  const paramNames = ['version', 'name', 'id'];
  let additionalParams = '';
  paramNames.forEach(paramName => {
    const paramValue = params.get(paramName);
    if (paramValue) {
      additionalParams += `&${paramName}=${paramValue}`;
    }
  });
  additionalParams += '&q=90&inputFormat=WebP';
  const baseImageSrc = `${url.origin}${url.pathname}?externalMediaId=${baseParams}${additionalParams}${sizeParams}`;
  const imageSrc = backgroundColor ? encodeURI(`${baseImageSrc}&ib=${encodeURIComponent(backgroundColor)}`) : encodeURI(baseImageSrc);
  return {
    imageSrc,
    sizeValue,
    backgroundColor,
    fontSizeValue
  };
};
exports.useCheckoutImage = useCheckoutImage;
